import { configureStore } from "@reduxjs/toolkit";
import cmsReducer from "./features/cms/cmsSlice";
import singleGroupReducer from "./features/singleGroup/singleGroupSlice";

export default configureStore({
  reducer: {
    cms: cmsReducer,
    singleGroup: singleGroupReducer,
  },
});
